import styled from 'styled-components'

import { TypeStyle, fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Card = styled.div<{ isPDP: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${o => (o.isPDP ? o.theme.spacing(6) : o.theme.spacing(5, 0))};
  justify-content: space-between;
  column-gap: ${o => o.theme.spacing(6)};

  ${fromMd} {
    flex-direction: row;
  }
`

/**
 * Used to wrap 'review' content (stars, title, date, content).
 */
export const ReviewContent = styled.div`
  ${fromMd} {
    width: 100%;
    flex-shrink: 1;
  }
`

export const ThumbnailsSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${o => o.theme.spacing(2)};
  margin-top: ${o => o.theme.spacing(6)};
`

export const ThumbnailWrapper = styled.div`
  width: ${o => o.theme.spacing(24)};
  ${fromMd} {
    width: ${o => o.theme.spacing(16.5)};
  }
`

export const ThumbnailsOverflow = styled(TypeStyle.HeadlineExtraExtraSmall)`
  display: flex;
  cursor: pointer;
  user-select: none;
  width: ${o => o.theme.spacing(10)};
  height: ${o => o.theme.spacing(10)};
  border: ${o => o.theme.spacing(0.5)} solid #e6e6e6;
  border-radius: ${o => o.theme.spacing(20)};
  background: white;
  justify-content: center;
  align-items: center;

  ${fromMd} {
    display: none;
  }
`

/**
 * Used to wrap 'reviewer' content (name, height, weight, fit, occupation, size purchased).
 */
export const PurchaseDetailsWrapper = styled.div<{ hasContent: boolean }>`
  background-color: ${o => (o.hasContent ? o.theme.color.fill.subtle : 'transparent')};
  border-radius: 5px;
  color: ${o => o.theme.color.stroke.neutral.text.primary.on.subtle};
  ${fromMd} {
    min-width: ${o => o.theme.spacing(42.5)};
  }
  ${untilMd} {
    margin-top: ${o => (o.hasContent ? o.theme.spacing(6) : '0')};
  }
`

export const PurchaseDetails = styled.div`
  padding: ${o => o.theme.spacing(5)};
`

/**
 * Contains `StarRating` and `CreatedAtDate` content.
 */
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CreatedAtDate = styled(TypeStyle.BodyNano)`
  font-weight: 500;
  color: ${o => o.theme.color.stroke.neutral.text.primary.on.subtle};
`

export const Title = styled(TypeStyle.HeadlineExtraSmall)`
  display: block;
  font-size: ${o => o.theme.typography.font.size[18]};
  color: ${o => o.theme.color.stroke.neutral.text.primary.on.subtle};
  margin-top: ${o => o.theme.spacing(4)};
`

/**
 * Container for `review.content`. Content should be wrapped in `ExpandableText` or something similar.
 */
export const BodyText = styled(TypeStyle.BodyDefault)`
  color: ${o => o.theme.color.stroke.neutral.text.primary.on.subtle};
  margin-top: ${o => o.theme.spacing(6)};
`

export const ReviewerName = styled.h3`
  display: inline-block;
  font-size: ${o => o.theme.typography.font.size[13]};
  font-weight: bold;
  margin-bottom: ${o => o.theme.spacing(3.5)};
`

export const DetailsItem = styled.li`
  padding: ${o => o.theme.spacing(0)};
`

export const DetailsList = styled.ul`
  margin: ${o => o.theme.spacing(0)};
  font-size: ${o => o.theme.typography.font.size[11]};
  line-height: 1.7em;
  list-style: none;

  & > ${DetailsItem} {
    padding: ${o => o.theme.spacing(0)};
  }
`
